export const STORAGE_KEY_BRANCH_ORDER = "colaboradores-branch-order";

export const loadBranchOrder = (): string[] | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_BRANCH_ORDER);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const saveBranchOrder = (order: string[]) => {
  try {
    localStorage.setItem(STORAGE_KEY_BRANCH_ORDER, JSON.stringify(order));
  } catch (e) {
    console.warn("No se pudo guardar el orden de sucursales", e);
  }
};
